import { TREE_ROOT_NODE_ID, TreeNodeFolder } from '@/entities/Tree';
import { TreeStore } from '@/stores/local/shared/TreeStore';

function findFolderStore(treeStore: TreeStore, targetId: string): TreeStore | null {
  const stack: TreeStore[] = [treeStore];

  while (stack.length > 0) {
    const current = stack.pop()!;

    if (current.data.type === 'folder' && current.data.id === targetId) {
      return current;
    }

    if (current.children.length > 0) {
      stack.push(...current.children);
    }
  }

  return null;
}

function collectFolderNamesFromStore(folderStore: TreeStore): string[] {
  const names: string[] = [];
  let current: TreeStore | undefined = folderStore;

  while (current && current.data.type === 'folder') {
    const folder = current.data as TreeNodeFolder;

    if (folder.id !== TREE_ROOT_NODE_ID) {
      names.push(folder.name);
    }

    current = current.parent;
  }

  return names;
}

export function getFolderAncestorNames(treeStore: TreeStore, folderId: string | null | undefined): string[] {
  if (!folderId || folderId === TREE_ROOT_NODE_ID) {
    return [];
  }

  const folderStore = findFolderStore(treeStore, folderId);

  if (!folderStore) {
    return [];
  }

  return collectFolderNamesFromStore(folderStore);
}
